import React from 'react'
import { motion } from "motion/react"
import SkillDetail from './SkillDetail'
import { variants, useRevealInitial } from "../lib/motion"
import { SkillsCardData } from "../Data/SkillsCardData.js"

function SkillsCard() {
  const initial = useRevealInitial("hidden");
  return (
    <section className="mx-auto max-w-2xl px-6 py-16" id="skills">
      <span className="font-mono text-sm uppercase tracking-widest text-signal-400">{"// 02 Skills"}</span>
      <h2 className="mt-3 mb-8 text-3xl font-semibold text-mist-100">Skills</h2>

      <div className="flex flex-col gap-8">
        {Object.keys(SkillsCardData).map((category) => (
          <div key={category}>
            <h3 className="mb-3 font-mono text-sm text-mist-500">{category}</h3>
            <motion.div
              className="flex flex-wrap gap-3"
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={variants.staggerContainer}
            >
              {SkillsCardData[category].map((skill, skillIndex) => (
                <motion.div key={skillIndex} variants={variants.fadeUp}>
                  <SkillDetail imgsrc={skill.imgsrc} alt={skill.text} text={skill.text} />
                </motion.div>
              ))}
            </motion.div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default SkillsCard
